import { cn } from '../../../utils/cn';
import { useLanguage } from '../../../features/language/useLanguage';
import type { SalesOrder } from '../../../types/salesOrder';

const STATUS_COLORS: Record<SalesOrder['status'], string> = {
  Delivered: 'bg-green-100 text-green-800',
  Sent: 'bg-blue-100 text-blue-800',
  Cancelled: 'bg-red-100 text-red-800',
  Draft: 'bg-gray-100 text-gray-800',
};

const STATUS_LABEL_KEYS: Record<SalesOrder['status'], string> = {
  Draft: 'salesOrder.list.status.draft',
  Sent: 'salesOrder.list.status.sent',
  Delivered: 'salesOrder.list.status.delivered',
  Cancelled: 'salesOrder.list.status.cancelled',
};

interface SalesOrderStatusBadgeProps {
  status: SalesOrder['status'];
  /** Layout classes for the wrapper (differs between the mobile card and desktop table). */
  className?: string;
}

/** Colored status pill for a sales order, used in both the mobile card and desktop row. */
export function SalesOrderStatusBadge({ status, className }: SalesOrderStatusBadgeProps) {
  const { t } = useLanguage();
  return (
    <span className={cn(STATUS_COLORS[status] ?? STATUS_COLORS.Draft, className)}>
      {t(STATUS_LABEL_KEYS[status], undefined, status)}
    </span>
  );
}
